import { createEventTracker } from '../util';
import { AllowOverageModalAnalytics, AllowOveragesToggleAnalytics } from './types';

export const trackAllowOveragesModalOpened = createEventTracker<AllowOverageModalAnalytics>(
  'Allow Overages Modal Opened',
);

export const trackToggleOnOverages =
  createEventTracker<AllowOveragesToggleAnalytics>('Overages Turned On');
